import React from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/Button';
import RatingScale from './RatingScale.js';
import { sendFeedback } from '../../actions/order';
import Modal from '../../../components/common/Modal';
import { showModal, hideModal } from '../../../actions/modal';
import { getEncodedString } from '../../../modules/ajio-util/stringDecoder';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreens from '../../../refresh/constants/luxeScreenType';

class FeedbackRating extends React.Component {
  constructor(props) {
    super(props);
    this.label = {
      feedBackMessage: 'Thanks for your feedback'
    };
    this.state = {
      ratingChosen: props.rating,
      comments: '',
      showCommentSection: false,
      isfeedBacksubmitted: false
    };
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.selectRating = this.selectRating.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rating !== this.props.rating) {
      this.setState({
        ratingChosen: nextProps.rating
      });
    }
  }

  selectRating(rating) {
    this.setState({
      ratingChosen: rating,
      showCommentSection: true
    });
  }

  handleTextChange(e) {
    this.setState({
      comments: e.target.value
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { order = {}, source = '', newDesignLuxe } = this.props;
    const {
      luxeStore,
      orderConfirmation: { screenName = '', screenType = '' }
    } = luxeScreens;
    const { ratingChosen, comments } = this.state;
    if (newDesignLuxe) {
      gtmEventPush({
        event: 'feedback_rating',
        event_category: 'order confirmation interactions',
        event_action: 'feedback',
        event_label: ratingChosen,
        rating: ratingChosen,
        comments,
        page_type: screenType,
        store_type: luxeStore
      });
      gtmEventPush({
        event: 'order_confirm_interaction',
        event_category: 'order confirmations interactions',
        event_action: 'user interactions',
        event_label: 'continue shopping',
        page_type: screenType,
        store_type: luxeStore
      });
    }
    if (this.state.ratingChosen === '') {
      window.location = '/';
    } else {
      const feedbackObj = {
        loginId: order.user.uid,
        orderId: order.code,
        channel: source,
        comments: getEncodedString(this.state.comments),
        rating: `NPS_${this.state.ratingChosen}`
      };
      sendFeedback(feedbackObj).then(response => {
        this.setState({ isfeedBacksubmitted: true });
      });
    }
  }

  closeModal = () => {
    this.props.hideModal('thanku-feedback-popup');
    window.location = '/';
  };

  showFeedbackThankuMsgModal = () => {
    const { feedBackMessage = '' } = this.label;
    this.props.showModal('thanku-feedback-popup');
    return (
      <div className="thanku-feedback-popup">
        <Modal name="thanku-feedback-popup" className="thanku-feedback-popup inactive center-feedback-popup" show>
          <div className="feedback-msg">{feedBackMessage}</div>
          <div
            className="thanku-msg-action"
            onClick={this.closeModal}
            role="button"
            tabIndex={0}
            aria-label="Done"
          >
            <span className="thanku-msg-action-text">DONE</span>
          </div>
        </Modal>
      </div>
    );
  };

  render() {
    const { ratingChosen, showCommentSection = false, isfeedBacksubmitted } = this.state;
    const { source = '', newDesignLuxe } = this.props;
    return (
      <div className="feedback-rating">
        <RatingScale ratingChosen={ratingChosen} selectRating={this.selectRating} />
        <form onSubmit={this.handleSubmit}>
          {showCommentSection && (
            <div className="nps-comment custom-pd">
              <div>Comments (optional)</div>

              <div>
                <textarea
                  rows="4"
                  cols="50"
                  className="nps-comment-textbox"
                  value={this.state.comments}
                  onChange={this.handleTextChange}
                  aria-label="Comments"
                  maxLength={255}
                />
              </div>
            </div>
          )}

          <div className={`${source == 'desktop' ? 'custom-pd' : ''}`}>
            <input
              type="submit"
              id={`fdbck-submit-${source == 'WEB' ? 'web' : 'msite'}`}
              className="btn-gold"
              aria-label={newDesignLuxe ? "CONTINUE SHOPPING" : "SUBMIT & CONTINUE"}
              value={newDesignLuxe ? 'CONTINUE SHOPPING' : 'SUBMIT & CONTINUE'}
              tabIndex={0}
              onClick={e=>{
                segmentEventPush({
                      event: 'NPS Interaction',
                      comment_given: (this.state.comments.length > 0),
                      error_message: '',      
                      nps_given: this.state.ratingChosen ? true : false,
                      order_id: this.props.order?.code,
                      payment_mode: '',        
                      screen_name: 'thank you page'
                    })
                }
              }
            />
          </div>
        </form>
        {isfeedBacksubmitted && source === 'desktop' && this.showFeedbackThankuMsgModal()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { order = {}, flags } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    order,
    newDesignLuxe
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FeedbackRating);
